var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 2H12C12.8284 2 13.5 2.67157 13.5 3.5V12.5C13.5 13.3284 12.8284 14 12 14H3C2.17157 14 1.5 13.3284 1.5 12.5V3.5C1.5 2.67157 2.17157 2 3 2ZM0 3.5C0 1.84315 1.34315 0.5 3 0.5H12C13.6569 0.5 15 1.84315 15 3.5V12.5C15 14.1569 13.6569 15.5 12 15.5H3C1.34315 15.5 0 14.1569 0 12.5V3.5ZM3.52605 8.05617L5.85994 10.3901L11.787 4.46858L12.5762 5.25774L5.85994 11.974L2.73129 8.84533L3.52605 8.05617Z","fill":"currentColor"}));
}

SVGIcon.defaultProps = {"width":"15","height":"16","viewBox":"0 0 15 16","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
